import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground border-border",
        // Custom skill badge variants
        infra: "border-transparent bg-skill-infra/15 text-skill-infra",
        network: "border-transparent bg-skill-network/15 text-skill-network",
        server: "border-transparent bg-skill-server/15 text-skill-server",
        cloud: "border-transparent bg-skill-cloud/15 text-skill-cloud",
        tools: "border-transparent bg-skill-tools/15 text-skill-tools",
        hardware: "border-transparent bg-skill-hardware/15 text-skill-hardware",
        // Certification badge
        cert: "border-primary/30 bg-primary-soft text-primary font-semibold",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
